import { render } from "./ReservedOrderView.vue?vue&type=template&id=bdd1475a&scoped=true&ts=true"
import script from "./ReservedOrderView.vue?vue&type=script&lang=ts"
export * from "./ReservedOrderView.vue?vue&type=script&lang=ts"

import "./ReservedOrderView.vue?vue&type=style&index=0&id=bdd1475a&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution.Cashier/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdd1475a"]])

export default __exports__